const buttonGroup = (tokens) => {
    const { semantic, component: { button, splitButton }, } = tokens;
    return {
        MuiButtonGroup: {
            defaultProps: {
                disableElevation: true,
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    gap: splitButton.gap.value,
                    ".MuiButtonGroup-grouped": {
                        minWidth: "auto",
                        "&:not(:last-of-type)": {
                            borderWidth: semantic.borderWidth.none.value,
                        },
                        "&.MuiButton-outlined": {
                            borderWidth: button.secondary.default.borderWidth.value,
                            borderRightColor: button.secondary.default.borderColor.value,
                        },
                        "&:focus": {
                            zIndex: "1",
                            "&:hover": {
                                boxShadow: button.focus.boxShadow.value.stringValue,
                            },
                        },
                    },
                },
            },
        },
    };
};
export default buttonGroup;
//# sourceMappingURL=buttonGroup.js.map